module.exports = __webpack_public_path__ + "img/xiaogx.7923e8e0.jpg";